import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
  useState,
} from 'react';
import _isNull from 'lodash/isNull';
import _isEmpty from 'lodash/isEmpty';
import Loader from '../../../../../components/spinner/Loader';

function Iframe(
  {
    src,
    style = {},
    renderFn,
    config,
    title = '',
    enablePostMessage = false,
    targetDomain = '*',
    language,
    device,
  },
  ref
) {
  const frameRef = useRef(null);
  const [frameWindow, setFrameWindow] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const [loaded, setLoaded] = useState(true);
  const [check, setCheck] = useState(false);

  const updatePage = () => {
    if (!isReady) {
      setIsReady(true);
    }
  };

  useEffect(() => {
    frameRef.current.src += '';
    updateHtml();
  }, [device]);

  useImperativeHandle(ref, () => ({
    contentWindow:
      frameRef.current.contentWindow || frameRef.current.contentDocument,
  }));

  useEffect(() => {
    if (!frameRef || !frameRef.current) {
      return;
    }
    const window =
      frameRef.current.contentWindow || frameRef.current.contentDocument;
    frameRef.current.addEventListener('load', () => {
      setFrameWindow(window);
      if (renderFn !== 'setPatientReport') {
        updatePage();
      }
    });
  }, [frameRef]);

  useEffect(() => {
    if (renderFn === 'setPatientReport') {
      window.addEventListener('message', e => {
        if (e.data && e.data.isPageReady) {
          setTimeout(() => {
            updatePage();
          });
        }
      });
    }
    setTimeout(() => {
      setCheck(true);
    }, 5000);
  }, []);

  useEffect(() => {
    if (check) {
      if (!isReady) {
        updatePage();
      }
    }
  }, [check]);

  useEffect(() => {
    updateHtml();
  }, [config, isReady, language, frameWindow]);

  const updateHtml = () => {
    if (isReady && renderFn === 'setCustomizationAndRerender') {
      setLoaded(false);
      return;
    }
    if (
      isReady &&
      !_isNull(frameWindow) &&
      !_isEmpty(config) &&
      !_isNull(config)
    ) {
      if (enablePostMessage) {
        setTimeout(() => {
          frameWindow.postMessage(config, targetDomain);
          setLoaded(false);
        }, 1000);
      } else if (!!frameWindow[renderFn]) {
        frameWindow[renderFn](config);
      }
    }
  };

  return (
    <>
      <iframe
        src={src}
        ref={frameRef}
        style={{...style, display: loaded && 'none'}}
        title={title}
      />
      {loaded && <Loader />}
    </>
  );
}

export default forwardRef(Iframe);
